import { nextTick, watch } from 'vue'

import { useMediaQuery } from './useMediaQuery'

interface GuestCountPromptHost {
  /** Whether Group Dining is selected with no party size yet. */
  needsGuestCount: () => boolean
  /** Opens the small-screen event-details panel, which holds the party size field there. */
  openMobilePanel: () => void
  /** Opens the navigation's party size popover, the desktop entry point. */
  openNavigationPrompt: () => void
}

/** Asks for the party size through the viewport's entry point whenever Group Dining lacks one. */
export function useGuestCountPrompt(host: GuestCountPromptHost) {
  const isDesktop = useMediaQuery('(min-width: 1024px)')

  const openGuestCountPrompt = (): void => {
    if (isDesktop.value) {
      host.openNavigationPrompt()
      return
    }

    host.openMobilePanel()
  }

  // The navigation filter mounts only for Group Dining, so wait for that render before opening it.
  watch(host.needsGuestCount, async (needsGuestCount) => {
    if (!needsGuestCount) return

    await nextTick()
    openGuestCountPrompt()
  })

  return { openGuestCountPrompt }
}
